export const languages = {
  en: "en",
  fi: "fi"
};
